import { openAuthModal } from './header';

import { IMicrofrontendsAPI } from 'shared/types/microfrontendsAPI';

export * from './header';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
    },
  };
}
